import styled, { css } from 'styled-components';

import { StyledTagProps, TextTransforms } from '../typings';
import { themeToken } from '../../utils/cpds-utils';

const colorMapper = (cpds) => {
  return {
    DEFAULT: {
      color: cpds.tag_color,
      border: cpds.tag_border,
      background: cpds.tag_background,
      hover_border: cpds.tag_hover_border,
      color_hover: cpds.tag_hover_color,
      border_radius: '0px',
    },
    UNCLICKABLE: {
      color: cpds.tag_unclickable_color,
      border: cpds.tag_unclickable_border,
      background: cpds.tag_unclickable_background,
      border_radius: '0px',
    },
    DISABLED: {
      color: cpds.tag_disabled_color,
      border: cpds.tag_disabled_border,
      background: cpds.tag_disabled_background,
      border_radius: '0px',
    },
    FILTER: {
      color: cpds.tag_filter_applied_color,
      border: cpds.tag_filter_applied_border,
      background: cpds.tag_filter_applied_background,
      border_radius: cpds.tag_border_radius,
    },
  };
};

export const CpdsFilterToken = styled.div`
  width: 10px;
  height: 1.5px;
  margin-left: 8px;
`;

const CpdsStyledTag = styled.div.attrs((props) => ({
  className: `${props.className || ''} cpds-meta-roman-medium-book-10`,
}))<StyledTagProps>`
  ${({
    theme: {
      styles: { cpds },
    },
    filterApplied = false,
    ...props
  }) => {
    const caseStyle = props.caseStyle || TextTransforms.NONE;
    const state = filterApplied ? `FILTER` : props.state || 'DEFAULT';

    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      width: fit-content;
      height: ${token.tag_height};
      background-color: ${colorMapper(token)?.[`${state}`]?.background || token.tag_background};
      color: ${colorMapper(token)?.[`${state}`]?.color || token.tag_color};
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 10px !important;
      text-transform: ${TextTransforms[caseStyle]};
      text-align: center;
      border-radius: ${colorMapper(token)?.[`${state}`]?.border_radius || token.tag_border_radius};
      ${state === 'DEFAULT'
        ? `
        transition: all 0.25s ease;
        &:hover {
          color: ${colorMapper(token)?.[`${state}`]?.color_hover || token.tag_hover_color};
          border-bottom:${colorMapper(token)?.[`${state}`]?.hover_border || token.tag_hover_border};
        }
        `
        : ``}

      ${state === 'FILTER'
        ? `
        border: ${colorMapper(token)?.[`${state}`]?.border || token.tag_filter_applied_border};
        padding: ${token.spacing.space_8} ${token.spacing.space_8};
      `
        : `
        border-bottom: ${colorMapper(token)?.[`${state}`]?.border || token.tag_border};
        padding: ${token.spacing.space_8} ${token.spacing.space_0};
      `}

      ${CpdsFilterToken} {
        background-color: ${colorMapper(token)?.[`${state}`]?.color || token.tag_color};
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export { CpdsStyledTag };
